import URI from 'urijs';

import { getRoutePathById } from '@bingads-webui-react/with-site-map';

const getURIObj = ({
  siteMapId, cid, aid, uid, siteMap, extraSearch,
}) => {
  const path = getRoutePathById(siteMap, siteMapId);
  const uri = new URI(path);
  uri.addSearch({
    cid,
    aid,
    uid,
    ...extraSearch,
  });
  return uri;
};

export const getURL = ({
  siteMapId, cid, aid, uid, siteMap, extraSearch,
}) => {
  const uri = getURIObj({
    siteMapId, cid, aid, uid, siteMap, extraSearch,
  });
  return uri.toString();
};

export const generateGetURLBySiteMapId = ({
  siteMap, cid, aid, uid,
}) => (siteMapId, { extraSearch } = {}) => getURL({
  siteMapId, cid, aid, uid, siteMap, extraSearch,
});

export const navigate = ({
  history, siteMapId, cid, aid, uid, siteMap, extraSearch,
}) => {
  const uri = getURIObj({
    siteMapId, cid, aid, uid, siteMap, extraSearch,
  });
  history.push(uri.toString());
};

export const generateNavigateBySiteMapId = ({
  history, siteMap, cid, aid, uid,
}) => (siteMapId, { extraSearch } = {}) => navigate({
  history, siteMapId, cid, aid, uid, siteMap, extraSearch,
});
